import {createEntityMeta,SyncStatus} from '../offline/entity.js';
import {createItemPreparation,updateItemPreparation} from './preparation.js';

export const ITEM_PREPARATION_ENTITY_TYPE='item_preparation';
export const EDITABLE_PREPARATION_SESSION_STATUSES=Object.freeze(['draft','planned','preparation','ready']);
const EDITABLE=new Set(EDITABLE_PREPARATION_SESSION_STATUSES);

function required(value,label){
  const text=String(value||'').trim();
  if(!text)throw new TypeError(label+' is required');
  return text;
}

function assertEditable(status){
  const value=String(status||'').trim().toLowerCase();
  if(!EDITABLE.has(value))throw new Error('ITEM_PREPARATION_LOCKED_AFTER_START');
}

function clean(row){
  const copy={...row};
  delete copy.key;
  delete copy.entityType;
  return copy;
}

function merge(existing,domain,{now}){
  if(existing){
    return {
      ...clean(existing),
      ...domain,
      id:existing.id,
      userId:existing.userId,
      itemId:existing.itemId
    };
  }
  return {
    ...createEntityMeta({id:domain.itemId,now,syncStatus:SyncStatus.PENDING_CREATE}),
    ...domain,
    id:domain.itemId
  };
}

export function createItemPreparationStore({
  repository,
  queue,
  userId,
  now=()=>new Date().toISOString()
}={}){
  if(!repository?.get||!repository?.put)throw new TypeError('repository with get/put is required');
  if(!queue?.enqueue||!queue?.markConflict)throw new TypeError('sync queue is required');
  const owner=required(userId,'userId');

  function assertOwner(row){
    if(row?.userId!==owner)throw new Error('ITEM_PREPARATION_OWNER_MISMATCH');
    return row;
  }

  async function get(itemId){
    const id=required(itemId,'itemId');
    const row=await repository.get(ITEM_PREPARATION_ENTITY_TYPE,id);
    if(!row)return null;
    return Object.freeze(assertOwner(row));
  }

  async function save(itemId,changes={}, {sessionStatus='draft'}={}){
    assertEditable(sessionStatus);
    const id=required(itemId,'itemId');
    const existing=await repository.get(ITEM_PREPARATION_ENTITY_TYPE,id);
    if(existing){
      assertOwner(existing);
      if(existing.syncStatus===SyncStatus.CONFLICT)throw new Error('ITEM_PREPARATION_CONFLICT');
    }

    const domain=existing
      ?updateItemPreparation(clean(existing),changes)
      :createItemPreparation({...changes,itemId:id,userId:owner});

    const entity=merge(existing,domain,{now:now()});
    const operation=existing&&Number(existing.serverVersion)>0?'update':'create';
    return queue.enqueue(ITEM_PREPARATION_ENTITY_TYPE,entity,operation);
  }

  async function markConflict(itemId,details){
    const current=await get(itemId);
    if(!current)throw new Error('ITEM_PREPARATION_NOT_FOUND');
    return queue.markConflict(ITEM_PREPARATION_ENTITY_TYPE,current,details);
  }

  return Object.freeze({get,save,markConflict});
}
